
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-graph-demo-xflow-components-xflow-graph"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.en.md?type=demo')
};